function Line() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      viewBox='0 0 45 45'
    >
      <circle cx='22.5' cy='22.5' r='20' fill='#fff'></circle>
      <defs>
        <path id='A' d='M8.5 17.5h28v9.8h-28z'></path>
      </defs>
      <clipPath id='B'>
        <use xlinkHref='#A'></use>
      </clipPath>
      <g clipPath='url(#B)'>
        <path
          fill='#5d2e7a'
          d='M18.2 17.5h-1.5c-.2 0-.4.2-.4.4v9c0 .2.2.4.4.4h1.5c.2 0 .4-.2.4-.4v-9c0-.2-.2-.4-.4-.4zm9.9 0h-1.5c-.2 0-.4.2-.4.4v5.3l-4.1-5.5h-1.6c-.2 0-.4.2-.4.4v9c0 .2.2.4.4.4H22c.2 0 .4-.2.4-.4v-5.4l4.1 5.6s0 .1.1.1h1.6c.2 0 .4-.2.4-.4v-9c-.1-.3-.3-.5-.5-.5zm-13.4 7.6h-3.9V18c0-.2-.2-.4-.4-.4H9c-.2 0-.4.2-.4.4v9c0 .1 0 .2.1.3.1 0 .2.1.3.1h5.8c.2 0 .4-.2.4-.4v-1.5c-.1-.3-.3-.4-.5-.4zm21.4-5.3c.2 0 .4-.2.4-.4V18c0-.2-.1-.4-.4-.4h-5.8c-.1 0-.2 0-.3.1 0 .1-.1.2-.1.3v9c0 .1 0 .2.1.3.1 0 .2.1.3.1h5.8c.2 0 .4-.2.4-.4v-1.5c0-.2-.2-.4-.4-.4h-3.9v-1.5h3.9c.2 0 .4-.2.4-.4v-1.3c0-.2-.1-.4-.4-.4h-3.9V20h3.9v-.2z'
        ></path>
      </g>
    </svg>
  );
}

export default Line;
